var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-info-wrapper" }, [
    _c(
      "div",
      { staticClass: "user-info-container flex justify-space-between" },
      [
        _c("div", { staticClass: "user-info flex align-center" }, [
          false
            ? _c("div", { staticClass: "avatar" }, [
                _c("img", {
                  attrs: { src: "https://placehold.co/100x100", alt: "" }
                })
              ])
            : _vm._e(),
          _c("div", { staticClass: "details" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("Self Performance Review - 2024")
            ]),
            _c("div", { staticClass: "user-details" }, [
              _c("b", [_vm._v(_vm._s(_vm.fullName))])
            ])
          ])
        ]),
        false
          ? _c("div", { staticClass: "progress-container" }, [
              _c("div", {
                staticClass: "progress-bar",
                style: {
                  width: _vm.progresswidth,
                  backgroundImage: _vm.progressBackground
                }
              }),
              _vm._m(0)
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("span", [_vm._v("1/10")]),
      _c("span", { staticClass: "publish-text" }, [_vm._v("Publish Review")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }